/** Owned Media — vista "Archivados" (§8.6): Lead OMC, admins y el GP de la cuenta; se puede restaurar y queda registrado. */
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ArchiveRestore } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { WinclapLoader } from '@/components/ui/winclap-loader';
import { trpc } from '@/lib/trpc';
import { useOmlMutations } from '@/hooks/useOml';

export function OmlArchivedPage() {
  const { t } = useTranslation();
  const q = trpc.oml.accounts.listArchived.useQuery();
  const m = useOmlMutations();
  if (q.isLoading) return <div className="flex justify-center py-20"><WinclapLoader size={48} className="text-foreground/25" /></div>;
  const rows = q.data ?? [];
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-bold">{t('oml.archived.title', 'Cuentas archivadas')}</h1>
        <p className="text-sm text-muted-foreground">{t('oml.archived.subtitle', 'Salieron de todas las vistas con todo su contenido. Restaurar las devuelve a Cerrada y queda registrado.')}</p>
      </div>
      <div className="rounded-md border">
        <Table>
          <TableHeader><TableRow><TableHead>{t('oml.transversal.account', 'Cuenta')}</TableHead><TableHead>{t('oml.archived.when', 'Archivada el')}</TableHead><TableHead>{t('oml.archived.by', 'Por')}</TableHead><TableHead /></TableRow></TableHeader>
          <TableBody>
            {rows.map((a) => (
              <TableRow key={a.id}>
                <TableCell><Link to={`/owned-media/accounts/${a.id}`} className="text-primary hover:underline">{a.name}</Link> <span className="text-xs text-muted-foreground">· {a.client}</span></TableCell>
                <TableCell>{a.archivedAt ? new Date(a.archivedAt).toLocaleDateString() : '—'}</TableCell>
                <TableCell>{a.archivedBy ?? '—'}</TableCell>
                <TableCell className="text-right"><Button size="sm" variant="outline" disabled={m.restoreAccount.isPending} onClick={() => m.restoreAccount.mutate({ accountId: a.id }, { onSuccess: () => q.refetch() })}><ArchiveRestore className="h-4 w-4 mr-1" />{t('oml.table.restore', 'Restaurar')}</Button></TableCell>
              </TableRow>
            ))}
            {rows.length === 0 && <TableRow><TableCell colSpan={4} className="text-center text-muted-foreground py-8">{t('oml.archived.empty', 'No hay cuentas archivadas.')}</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
